const minicart = {
    trigger: $('.js-trigger-minicart'),
    elem: $('.minicart'),
    overlay: false,
    active: false,
    callback: false
}

const account = {
    trigger: $('.js-trigger-account'),
    elem: $('.header-account__sub'),
    overlay: false,
    active: false,
    callback: false
}

const navigation = {
    trigger: $('.js-trigger-navigation'),
    elem: $('.header__navigation'),
    overlay: true,
    active: false,
    callback: false
}

const aside = {
    trigger: $('.js-trigger-aside'),
    elem: $('.l-aside'),
    overlay: true,
    active: false,
    callback: {
        show: function () {
            // $('.l-content, .l-footer').addClass('is-sided');
            $(window).scrollTop(0);
        },
        hide: function () {
            // $('.l-content, .l-footer').removeClass('is-sided');
        }
    }
}

const search = {
    trigger: $('.js-trigger-search'),
    elem: $('.header-search'),
    overlay: true,
    allowScroll: true,
    active: false,
    callback: {
        show: function () {
            $('.header-search')
                .slideDown(250)
                .find('.c-form__input').trigger('focus');
        },
        hide: function () {
            $('.header-search').slideUp(250);
        }
    }
}

const autocomplete = {
    trigger: $('.fake'),
    elem: $('.header-search > div'),
    overlay: true,
    allowScroll: true,
    active: false,
    callback: {}
}

const $subAsideTrigger = $('.js-trigger-subaside');

let activeElement;

function toggleElem(object) {
    if (object.active) {
        hideElem(object);
    } else {
        showElem(object);
    }
}

function showElem(object) {
    const isAutocomplete = object == autocomplete;

    if (activeElement && (activeElement != search || !isAutocomplete)) {
        hideElem(activeElement);
    }

    if (!isAutocomplete) {
        object.trigger.addClass('is-active');
        object.elem.addClass('is-active');
    }

    if (object.overlay) {
        showOverlay(250, object.allowScroll);
    }

    if (object.callback && object.callback.show) {
        object.callback.show();
    }

    object.active = true;

    activeElement = object;
}

function hideElem(object) {
    const isAutocomplete = object == autocomplete;

    if (isAutocomplete && checkMedia('cxs,xs')) {
        hideElem(search);
    }

    if (!isAutocomplete) {
        object.trigger.removeClass('is-active');
        object.elem.removeClass('is-active');
    }

    if (object.overlay) {
        hideOverlay();
    }

    if (object.callback && object.callback.hide) {
        object.callback.hide();
    }

    object.active = false;
}

Event.on('Autocomplete.show', function () {
    toggleElem(autocomplete);
    // showOverlay();
});

$(function() {

    $('body').on('click', function (event) {
        if (activeElement && activeElement.active) {
            if (!$(event.target).closest(activeElement.elem).length && !$(event.target).closest(activeElement.trigger).length) {
                hideElem(activeElement);
            }
        }
    });

    $('.js-open-login-modal').on('click', function(event) {
        event.preventDefault();

        $('#login-modal').modal('show');
    });

    /* navigation */
    navigation.trigger.on('click', function() {
        toggleElem(navigation);
    });

    $('.js-close-navigation').on('click', function() {
        hideElem(navigation);
    });

    /* search */
    $('.js-trigger-search').on('click', function (event) {
        event.preventDefault();

        toggleElem(search);
    });

    /* aside */
    aside.trigger.on('click', function(event) {
        event.preventDefault();

        toggleElem(aside);
    });

    $subAsideTrigger.on('click', function (event) {
        const $aside = $('.aside-menu'),
            $subAside = $('.aside-submenu');

        event.preventDefault();

        if ($subAside.hasClass('is-active')) {
            $subAside.removeClass('is-active');
            $aside.removeClass('is-sided');
        } else {
            $subAside.addClass('is-active');
            $aside.addClass('is-sided');
        }
    });

    /* minicart */
    minicart.trigger.on('click', function (event) {
        if ($('.c-var .lg-is-visible').is(':visible') || $('.c-var .md-is-visible').is(':visible') || $('.c-var .sm-is-visible').is(':visible')) {
            event.preventDefault();
        }

        toggleElem(minicart);
    });

    /* account */
    account.trigger.on('click', function (event) {
        event.preventDefault();

        toggleElem(account);
    });

    /* rcrumbs */
    if ($('.header__breadcrumb').length > 0) {
        $('.header__breadcrumb .rcrumbs').rcrumbs({
            nbFixedCrumbs: 1,
            animation: {
                activated: false
            },
            callback: {
                postCrumbsListDisplay: function() {
                    // console.log('je to tam');
                }
            }
        });
    }
});
